module.exports = __webpack_public_path__ + "static/media/Icon__DAO--Project.dd7b5db6.png";